module.exports = __webpack_public_path__ + "static/media/left-chevron.b9ec3559.svg";